export default __webpack_public_path__ + "maps-guides-view-annotation-z-index-960-a921609ba777445160257446661c55f5.png";